import { StorageInstallationStatementModel } from 'src/Libs/installation-statement/models'
import { PhotovoltaicTrackerApiDto, PhotovoltaicTrackerModel } from 'src/Libs/installation-statement/models/photovoltaic'
import {
  InstallationStatementApiDto,
  InstallationStatementModel,
  StorageInstallationStatementApiDto,
} from 'src/Libs/installation-statement/models/statement'
import { DirectionType, PowerOptimizerType } from 'src/Libs/installation-statement/types/photovoltaic'

const statementStorageDtoToModelTransformer = (statementStorage: StorageInstallationStatementApiDto): StorageInstallationStatementModel => {
  const {
    distanceTop,
    distanceFront,
    distanceLeft,
    distanceRight,
    temperature,
    loopImpedanceNL1,
    loopImpedanceNL2,
    loopImpedanceNL3,
    loopImpedancePEL,
    ...rest
  } = statementStorage
  return {
    distanceTop: distanceTop?.toString() ?? null,
    distanceFront: distanceFront?.toString() ?? null,
    distanceLeft: distanceLeft?.toString() ?? null,
    distanceRight: distanceRight?.toString() ?? null,
    temperature: temperature?.toString() ?? null,
    loopImpedanceNL1: loopImpedanceNL1?.toString() ?? null,
    loopImpedanceNL2: loopImpedanceNL2?.toString() ?? null,
    loopImpedanceNL3: loopImpedanceNL3?.toString() ?? null,
    loopImpedancePEL: loopImpedancePEL?.toString() ?? null,
    ...rest,
  }
}

const statementTrackersDtoToModelTransformer = (pvTracker: PhotovoltaicTrackerApiDto): PhotovoltaicTrackerModel => {
  return {
    name: pvTracker.name,
    appliedToAllString: false,
    pvStrings: pvTracker.pvStrings.map(pvString => {
      const { moduleType, pvOrientations, modulePeakPower, powerOptimizer, ...rest } = pvString
      return {
        pvModuleType: moduleType ?? '',
        moduleCount: pvString.pvOrientations[0].num,
        direction: pvString.pvOrientations[0].direction as DirectionType,
        orientation: pvString.pvOrientations[0].orientation,
        modulePeakPower: pvString.modulePeakPower ? Number(pvString.modulePeakPower).toFixed(2).toString() : null,
        powerOptimizer: powerOptimizer as PowerOptimizerType,
        ...rest,
      }
    }),
  }
}

export const statementDtoToModelTransfomer = (installationStatement: InstallationStatementApiDto): InstallationStatementModel => {
  const { installerName, installerSurname, storage, pvTrackers, installationStatementFiles, installationRequirements, ...rest } =
    installationStatement
  return {
    installerFirstName: installationStatement.installerName,
    installerLastName: installationStatement.installerSurname,
    storages: [statementStorageDtoToModelTransformer(storage)],
    pvTrackers: pvTrackers.map(tracker => statementTrackersDtoToModelTransformer(tracker)),
    files: installationStatementFiles,
    installationRequirements: !!installationRequirements,
    ...rest,
  }
}
